<template>
  <v-container  id="reservation-reception-reservation-info-component">
    <c-card>
      <v-row align="center">
        <v-col cols="12" sm="3" md="2" lg="3">
          <span class="red--text">*</span> 일자 선택
        </v-col>
        <v-menu
          ref="input.selectedDateMenu"
          v-model="input.selectedDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <div style="width:200px; margin-right:20px;">
              <v-text-field
                v-model="input.selectedDate"
                prepend-icon="event"
                readonly dense
                v-on="on"
              ></v-text-field>
            </div>
          </template>
          <c-date-picker
            v-model="input.selectedDate" @input="input.selectedDateMenu = false"
            firstDayOfWeek="1" :selectedDate="input.selectedDate"
            noTitle="true" scrollable="true" :min="nowDate" locale="ko-kr">
          </c-date-picker>
        </v-menu>
        <c-time-picker
          v-model="input.selectedTime"
          :minute-interval="5"
          :h-range="[0,24]"
          :readonly=false
          :autoScroll="true"
          :defaultAutoScrollValue="7"
        />
      </v-row>

      <v-row align="center">
        <v-col cols="12" sm="3" md="2" lg="3">
          <span class="red--text">*</span> 차량
        </v-col>
        <v-col>
          <!-- <v-row align="center">
            <v-col cols="2">
                <span>대수</span>
            </v-col>
            <v-col>
              <v-row>
                <v-radio-group  row v-model="input.selectedCarCnt" dense>
                  <v-radio
                    v-for="carCnt in carCntList"
                    :key="carCnt.value"
                    :label="carCnt.label"
                    :value="carCnt.value"
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </v-col>
          </v-row> -->
          <v-row align="center">
            <v-col cols="2">
                <span>차종</span>
            </v-col>
            <v-col>
              <v-row>
                <v-checkbox
                  label="모두선택"
                  v-model="input.selectAllCarType"
                  @change="onSelectAllCarType"
                  class="mr-3" dense>
                </v-checkbox>
                <v-checkbox
                  v-for="carType in getSeatCnt"
                  v-model="input.selectedCarTypeList"
                  :key="carType.configKey"
                  :label="carType.configName"
                  :value="carType.configValue"
                  @change="input.selectAllCarType = false"
                  class="mr-3" dense>
                </v-checkbox>
              </v-row>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="2">
                <span>옵션유무</span>
            </v-col>
            <v-col>
              <v-row>
                <v-checkbox
                  label="모두선택"
                  v-model="display.vehicleOption.all"
                  @change="onSelectAllVehicleOption"
                  class="mr-3" dense>
                </v-checkbox>
                <v-checkbox
                  label="옵션장착"
                  v-model="display.vehicleOption.equip"
                  @change="onSelectEquipAllVehicleOption"
                  class="mr-3" dense>
                </v-checkbox>
                <span class="pt-5">(</span>
                <v-checkbox
                  v-for="vehicleOption in getVehicleOption"
                  v-model="input.selectedVehicleOption"
                  :key="vehicleOption.configKey"
                  :label="vehicleOption.configName"
                  :value="vehicleOption.configValue"
                  @change="onSelectVehicleOption"
                  class="mr-3"
                  dense>
                </v-checkbox>
                <span class="pt-5">)</span>
                <v-checkbox
                  label="옵션 미장착"
                  v-model="input.selectedVehicleOption"
                  value="c_null"
                  @change="onSelectVehicleOption"
                  class="mr-3" dense>
                </v-checkbox>
              </v-row>
              <v-row>
                <span v-if="display.vehicleOption.comment">전체 차량 대상으로 배차가 진행됩니다.</span>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row align="center">
        <v-col cols="12" sm="3" md="2" lg="3">
          <span class="red--text">*</span>도움서비스 이용시간
        </v-col>
        <v-radio-group dense row v-model="input.selectedServiceTime">
          <v-radio
            v-for="serviceTime in serviceTimeList"
            :key="serviceTime.value"
            :label="serviceTime.label"
            :value="serviceTime.value"
          ></v-radio>
        </v-radio-group>
        <div style="width:120px;" v-if="input.selectedServiceTime == -1">
          <v-text-field
            v-model="input.selectedServiceInput"
            label="기타 시간 입력"
            v-mask="'####'"
          >
          </v-text-field>
        </div><span  v-if="input.selectedServiceTime == -1">분</span>
      </v-row>

      <v-row align="center">
        <v-col cols="12" sm="3" md="2" lg="3">
          <span>도움서비스 내용</span>
        </v-col>
        <v-text-field
          v-model="input.serviceComment"
          label="서비스 내용 (30자 이내)"
          maxlength="30"
          class="pr-12"
        ></v-text-field>
      </v-row>
    </c-card>
  </v-container>
</template>
<script>
  import CTimePicker from "../../../components/CTimePicker";
  import { mask } from 'vue-the-mask';

  export default {
    directives: { mask },
    components: {CTimePicker},
    props: {
      reservationData: {
        type: Object
      }
    },
    data() {
      return {
        maskPeople: '##',

        rules: {
          numOfPeople: (value) => value > 4 || '인원 수를 확인하세요.'
        },

        input: {
          selectedDate: this.$moment().add(1, 'day').format('YYYY-MM-DD'),
          selectedTime: '09:00',

          selectedVehicleOption: [],

          selectedCarCnt: 1,
          selectedCarTypeList: [],

          selectedServiceTime: 0,
          selectedServiceInput: '',

          serviceComment: null,

          selectedDateMenu: false,
          selectAllCarType: true,
          selectAllVehicleOption : false,
        },
        default: {
          selectedDate: this.$moment().add(1, 'day').format('YYYY-MM-DD'),
          selectedTime: '09:00',
          selectedCarCnt: 1,
          selectedServiceTime: 0,
          selectAllCarType: true,
        },
        display: {
          vehicleOption : {
            options: [],
            all: true,
            comment: true
          }
        },

        nowDate: this.$func.curDateString(),

        // carCntList: [
        //   {label: '1대', value: 1},
        //   {label: '2대', value: 2},
        // ],

        serviceTimeList: [
          {label: '없음', value:0},
          {label: '10분', value:10},
          {label: '20분', value:20},
          {label: '기타', value:-1}
        ],
      }
    },
    computed: {
      getSeatCnt() {
        return this.$store.state.config.seat_cnt;
      },
      getVehicleOption() {
        return this.$store.state.config.car_option.filter(item => item.configValue !=='c_all' && item.configValue !=='c_null' );
      },
    },
    created() {
      this.$store.state.config.car_option.forEach(item => {
        if(item.configValue !=='c_all') this.display.vehicleOption.options.push(item.configValue)
      })

      this.onSelectAllVehicleOption(true);
    },
    watch: {
      reservationData(newVal, oldVal) {
        if (!!newVal && Object.keys(newVal).length > 0) {
          const diff = Object.keys(newVal).filter(key => newVal[key] !== this.input[key]);
          if (diff.length > 0) {
            this.input = newVal;
            const checkServiceTime = this.serviceTimeList.filter(item => item.value === newVal.selectedServiceTime).length;

            this.onSelectVehicleOption()

            this.input = {
              ...newVal,
              selectedServiceTime: checkServiceTime > 0 ? newVal.selectedServiceTime : -1,
              selectedServiceInput: checkServiceTime > 0 ? '' : newVal.selectedServiceTime,
            }
          }
        } else {
          this.initData();
          this.onSelectAllCarType(true);
          this.onSelectAllVehicleOption(true);
        }
      },
      'input.selectedCarTypeList'(newVal) {
        if (newVal && this.getSeatCnt && newVal.length !== this.getSeatCnt.length) {
          this.input.selectAllCarType = false;
        }
      },
      'reservationData.selectedDate'(newVal) {
        //오늘 이후이고 예약 접수일 경우
        if (Object.keys(this.$route.params).length === 0) {
          if (this.$moment(newVal).isAfter(this.$moment())) {
            if (this.$moment(newVal).day() === 6 || this.$moment(newVal).day() === 0) {
              // 주말 운영시간으로 초기화
              this.input.selectedTime = this.$store.state.centerInfo.weekendFirstResv;
            } else {
              //평일 운영시간으로 초기화
              this.input.selectedTime = this.$store.state.centerInfo.weekdayFirstResv;
            }
          } else {
            // 오늘날짜에서는 t  + 30 min
            this.input.selectedTime = this.$moment().add(30, 'minutes').format('HH:mm')
          }
        }
      },
      input: {
        deep: true,
        handler(newVal) {
          this.$emit('update:reservationData', newVal);
        }
      },
    },
    methods: {
      initData() {
        this.input = this.$func.initObjectData(this.input, this.default);
      },
      onSelectAllCarType(flag) {
        if(flag)
          this.input.selectedCarTypeList = this.getSeatCnt.map(item=>item.configValue);
        else
          this.input.selectedCarTypeList = [];

      },
      onSelectVehicleOption() {
        let all_flag = this.display.vehicleOption.options.length === this.input.selectedVehicleOption.length ? true : false
        let equip_flag =
          this.display.vehicleOption.options.filter(option => option !== 'c_null').length ===
          this.input.selectedVehicleOption.filter(option => option !== 'c_null').length ? true : false

        this.display.vehicleOption.equip = equip_flag
        this.display.vehicleOption.all = all_flag
        this.display.vehicleOption.comment = all_flag
      },
      onSelectAllVehicleOption(flag) {
        this.display.vehicleOption.comment = flag
        this.display.vehicleOption.equip = flag
        this.input.selectedVehicleOption = flag ? this.display.vehicleOption.options : []
      },
      onSelectEquipAllVehicleOption(flag) {
        let c_null_flag = this.input.selectedVehicleOption.includes('c_null')
        this.input.selectedVehicleOption = []

        if(flag) {
          this.display.vehicleOption.options.forEach( item => {
            if(item !=='c_null') this.input.selectedVehicleOption.push(item)
          })
        }

        if(c_null_flag) this.input.selectedVehicleOption.push('c_null')
        let all_flag = this.display.vehicleOption.options.length === this.input.selectedVehicleOption.length ? true : false
        this.display.vehicleOption.all = all_flag
      }
    },
    mounted() {
      this.$emit('update:reservationData', this.input);
      this.onSelectAllCarType(true);
    }
  }
</script>
<style lang="scss" scoped>
  .info-card {
    width: 270px;
  }
</style>
